import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { OfferExpectation, OfferPersonal } from '../interfaces/offer.interface';
import { Contact } from '../interfaces/contact.interface';


@Injectable()
export class EmailService {
	protected emailUrl: string = 'https://www.capdesign.hu/services/aquaapartman/email.php';

	constructor(private http: Http) { }

	public sendOffer(expectation: OfferExpectation, personal: OfferPersonal): Observable<any> | any {
		let message: any[] = [];
		message.push(expectation);
		message.push(personal);
		console.log('E-mail küldése...');
		return this.http.post(this.emailUrl + '?type=offer', message)
			.map(response => {
				console.log('E-mail küldés sikeres', response);
				return response;
			})
			.catch(error => {
				console.log('E-mail küldés SIKERTELEN', error);
				return Observable.throw(error)
			})
	}

	public sendContact(contact: Contact): Observable<any> | any {
		console.log('E-mail küldése...');
		return this.http.post(this.emailUrl + '?type=contact', contact)
			.map(response => {
				console.log('E-mail küldés sikeres', response);
				return response;
			})
			.catch(error => {
				console.log('E-mail küldés SIKERTELEN', error);
				return Observable.throw(error)
			})
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/services/email.service.ts